// removed by extract-text-webpack-plugin
module.exports = {"register-fair-box":"register-fair-box","register-box-body":"register-box-body","section-heading":"section-heading","Select":"Select","rdw-editor-main":"rdw-editor-main","rdw-editor-toolbar":"rdw-editor-toolbar"};


//////////////////
// WEBPACK FOOTER
// ./components/fair/_FormCreateFair.scss
// module id = ./components/fair/_FormCreateFair.scss
// module chunks = 0